import { BoxDetection } from '@models';

export const getSortedLegs = (legs: BoxDetection[]): BoxDetection[] => {
  return legs
    ? legs
        .filter((leg: BoxDetection) => leg && leg.min.x !== 0)
        .sort((a: BoxDetection, b: BoxDetection) => a.center.x - b.center.x)
    : null;
};

export const getMiddleLeg = (legs: BoxDetection[]): BoxDetection => {
  const legsSorted = getSortedLegs(legs);
  return legsSorted[1] ?? null;
};
